/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/bubble-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 66 133',
    data: '<g data-name="Layer 2"><path pid="0" d="M0 0c36.45 0 66 29.77 66 66.5C66 103.23 36.45 133 0 133z" _fill="#fff" data-name="Layer 1"/></g>'
  }
})
